export const FETCH_USERS = 'ADMIN_USERS/FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'ADMIN_USERS/FETCH_USERS_SUCCESS';
export const FETCH_USERS_ERROR = 'ADMIN_USERS/FETCH_USERS_ERROR';
export const SAVE_USER = 'ADMIN_USERS/SAVE_USER';
export const SAVE_USER_SUCCESS = 'ADMIN_USERS/SAVE_USER_SUCCESS';
export const SAVE_USER_ERROR = 'ADMIN_USERS/SAVE_USER_ERROR';
export const DELETE_USER = 'ADMIN_USERS/DELETE_USER';
export const DELETE_USER_SUCCESS = 'ADMIN_USERS/DELETE_USER_SUCCESS';
export const DELETE_USER_ERROR = 'ADMIN_USERS/DELETE_USER_ERROR';
export const SET_ID_MODAL = 'ADMIN_USERS/SET_ID_MODAL';
export const SET_ACTIVE_PAGE = 'ADMIN_USERS/SET_ACTIVE_PAGE';
export const SET_FIELD = 'ADMIN_USERS/SET_FIELD';
export const SET_SORT = 'ADMIN_USERS/SET_SORT';
export const SET_SEARCH = 'ADMIN_USERS/SET_SEARCH';
export const SET_SEARCH_TYPE = 'ADMIN_USERS/SET_SEARCH_TYPE';
export const SET_PERMISSIONS = 'ADMIN_USERS/SET_PERMISSIONS';
export const ADD_PERMISSION = 'ADMIN_USERS/ADD_PERMISSION';
export const REMOVE_PERMISSION = 'ADMIN_USERS/REMOVE_PERMISSION';
export const SET_FIELDS = 'ADMIN_USERS/SET_FIELDS';
export const RESET_STATE = 'ADMIN_USERS/RESET_STATE';